import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TslApiService, TSL_API_HOST } from './tsl-api.service';
import { TslSessionService } from './tsl-session.service';

export interface TslApiModuleConfig {
  apiHost: string;
}

@NgModule({ imports: [], providers: [TslSessionService, TslApiService, provideHttpClient(withInterceptorsFromDi())] })
export class TslApiModule {
  static forRoot(config: TslApiModuleConfig): ModuleWithProviders<TslApiModule> {
    return {
      ngModule: TslApiModule,
      providers: [{ provide: TSL_API_HOST, useValue: config.apiHost }]
    };
  }
}
